
import { Placement } from '@post-office/placements-frontend/jsm-issue-view-details-section';
export default Placement;
